import { Flex, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { Icon } from 'src/design_system/atoms/icons/components/Icon'
import { useSelector } from 'src/hooks'

type CountDownPillProps = {
  timeLeft: number
}

export const CountDownPill = (props: CountDownPillProps) => {
  const { timeLeft } = props

  const screenWidth = useSelector(state => state.window.width)
  const isMobile = screenWidth <= 428

  return (
    <Flex
      flexDirection="row"
      alignItems="center"
      columnGap="x_75"
      backgroundColor="#fff"
      inset={{ vertical: '.25rem', horizontal: '.375rem' }}
      style={{
        borderRadius: '3.625rem',
        boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.08)',
      }}
    >
      <Icon name="stop_watch" size={14} color="#6B7280" />
      <Text
        type="body"
        content={`${timeLeft} Days Left`}
        whiteSpace="nowrap"
        style={{
          fontSize: isMobile ? '.65rem' : '.725rem',
          fontWeight: 700,
          fontFamily: 'Montserrat, san serif',
          color: '#6B7280',
        }}
      />
    </Flex>
  )
}
